<template >
    <div 
        id="indicator" 
        :style="{ width: widthBar+'px', height: widthBar/5+'px', borderRadius: widthBar/10+'px'}"
        v-b-tooltip.hover :title="ratio + tooltip"
        ref="indicator"
    >
        <div class="red_bar ind_bar left_50 border_left" ref="red">
        </div>
        <div class="green_bar ind_bar border_right" ref="green">
        </div>
        <div class="gray_bar ind_bar left_50 border_left" ref="gray_left">
        </div>
        <div class="gray_bar ind_bar border_right" ref="gray_right">
        </div>
        <div class="white_bar">
        </div>
    </div>
</template>

<script>
export default {
    name:"IndicatorBar",
    props: {
        widthBar: { type: Number, required: false, default: 100 },
        saveZone: { type: Array, required: false, default: () => [40,60]},
        value: { type: Number, required: false, default: 0 },
        ratio: { type: Number, required: false, default: 0 },
        tooltips: { type: Array, required: false, default: () => []}
    },
    data () {
        return {
        }
    },
    mounted: function() {
        // get all references
        var red = this.$refs.red;
        var green = this.$refs.green;
        var gray_left = this.$refs.gray_left;
        var gray_right = this.$refs.gray_right;
        var maxWidth = this.$refs.indicator.clientWidth /2;
        var style = null;
        // make style of left line over save zone
        if(this.value > this.saveZone[1]){
            // make calculations for width etc.
            var heightRed = red.clientHeight/2;
            var widthRed = maxWidth*((this.value - 50) *0.02);
            // make style changes
            style = red.style;
            style.borderRadius = "0 "+ heightRed +"px "+ heightRed +"px 0";
            style.maxWidth = maxWidth + "px";
            style.width = widthRed +"px";
            green.style.display = "none";
            gray_left.style.display = "none";
            gray_right.style.display = "none";
        }
        // make style of right line over save zone
        else if(this.value < this.saveZone[0]){
            // make calculations for width etc.
            var heightGreen = green.clientHeight/2;
            var widthGreen = (maxWidth*(1 - (this.value) *0.02));
            // make style changes
            style = green.style;
            style.borderRadius = heightGreen +"px 0 0 "+ heightGreen +"px";
            style.maxWidth = maxWidth + "px";
            style.width = widthGreen +"px";
            style.left = "calc(50% - "+ widthGreen +"px)";
            red.style.display = "none";
            gray_left.style.display = "none";
            gray_right.style.display = "none";
        }
        // make style of left line in save zone
        else if(this.value > 50){
            // make calculations for width etc.
            var heightGrayLeft = gray_left.clientHeight/2;
            var widthGrayLeft = (maxWidth*((this.value - 50) *0.02));
            // make style changes
            style = gray_left.style;
            style.borderRadius = "0 "+heightGrayLeft +"px "+ heightGrayLeft +"px 0";
            style.maxWidth = maxWidth + "px";
            style.width = widthGrayLeft +"px";
            red.style.display = "none";
            green.style.display = "none";
            gray_right.style.display = "none";
        }
        // make style of lright line in save zone
        else if(this.value < 50){
            // make calculations for width etc.
            var heightGrayRight = gray_right.clientHeight/2;
            var widthGrayRight = (maxWidth*(1 - (this.value *0.02)));
            // make style changes
            style = gray_right.style;
            style.borderRadius = heightGrayRight +"px 0 0 "+ heightGrayRight +"px";
            style.maxWidth = maxWidth + "px";
            style.width = widthGrayRight +"px";
            style.left = "calc(50% - "+ widthGrayRight +"px)";
            red.style.display = "none";
            gray_left.style.display = "none";
            green.style.display = "none";
        }
        else if(this.value == 50){
            red.style.display = "none";
            gray_left.style.display = "none";
            gray_right.style.display = "none";
            green.style.display = "none";
        }
    },
    computed: {
        tooltip: function(){
            var title = "";
            for (var i = 0; i < this.tooltips.length; i++){
                var tooltip = this.tooltips[i];
                // find best tooltip that fits its value between tooltips max and min
                if(tooltip.min <= this.value && tooltip.max >= this.value){
                    title = tooltip.title;
                    break;
                }
            }
            return title;
        }
    },
    methods: { 
    }
}
</script>

<style lang="scss">
@import "src/scss/custom";
@import "src/scss/utils";

#indicator {
    background-color: $indicator-background-color;
    position: relative;
}

.ind_bar{
    position: absolute;
    height: 100%;
}

.border_left{
    border-color: $indicator-background-color;
    border-style: solid;
    border-width: 2px 2px 2px 0;
}

.border_right{
    border-color: $indicator-background-color;
    border-style: solid;
    border-width: 2px 0 2px 2px;
}

.red_bar{
    background-color: $indicator-red;
}

.green_bar{
    background-color: $indicator-green;
}

.gray_bar{
    background-color: $indicator-gray;
}

.left_50{
    left: 50%;
}

.white_bar{
    position: absolute;
    height: 100%;
    width: 1%;
    left: 49.5%;
    background-color: white;
    z-index: 1000;
}
</style>
